export default __webpack_public_path__ + "static/media/Theurgic Dagger.d3634abf.jpg";